export const FETCH_STAFF = {
    START: 'FETCH_STAFF_START',
    SUCCESS: 'FETCH_STAFF_SUCCESS',
    ERROR: 'FETCH_STAFF_ERROR',
};

export const FETCH_FORM_DATA = {
    START: 'FETCH_FORM_DATA_START',
    SUCCESS: 'FETCH_FORM_DATA_SUCCESS',
    ERROR: 'FETCH_FORM_DATA_ERROR',
};

export const FETCH_ENROLLMENT_INFO = {
    START: 'FETCH_ENROLLMENT_INFO_START',
    SUCCESS: 'FETCH_ENROLLMENT_INFO_SUCCESS',
    ERROR: 'FETCH_ENROLLMENT_INFO_ERROR',
};

export const FETCH_AMP_NAV_DATA = {
    START: 'FETCH_AMP_NAV_DATA_START',
    SUCCESS: 'FETCH_AMP_NAV_DATA_SUCCESS',
    ERROR: 'FETCH_AMP_NAV_DATA_ERROR',
};

export const FETCH_ADDITIONAL_ENROLLMENT_INFO = {
    START: 'FETCH_ADDITIONAL_ENROLLMENT_INFO_START',
    SUCCESS: 'FETCH_ADDITIONAL_ENROLLMENT_INFO_SUCCESS',
    ERROR: 'FETCH_ADDITIONAL_ENROLLMENT_INFO_ERROR',
};

export const FETCH_MAS_TOKEN = {
    START: 'FETCH_MAS_TOKEN_START',
    SUCCESS: 'FETCH_MAS_TOKEN_SUCCESS',
    ERROR: 'FETCH_MAS_TOKEN_ERROR',
};

export const FETCH_ALL_RESULTS = {
    START: 'FETCH_RESULTS_START',
    SUCCESS: 'ALL_RESULTS_FETCHED',
    ERROR: 'FETCH_RESULTS_ERROR',
};

export const FETCH_ALL_ADDITIONAL_RESULTS = {
    START: 'FETCH_ADDITIONAL_RESULTS_START',
    SUCCESS: 'ALL_ADDITIONAL_RESULTS_FETCHED',
    ERROR: 'FETCH_ADDITIONAL_RESULTS_ERROR',
};

export const FETCH_D8_RESULTS = {
    START: 'UPDATE_RESULTS_START',
    SUCCESS: 'FETCH_D8_RESULTS',
    ERROR: 'FETCH_D8_RESULTS_ERROR',
};

export const FETCH_SHARED_RESULTS = {
    D8: 'FETCH_D8_RESULTS',
    LECTURA: 'FETCH_LECTURA_RESULTS',
    R3D: 'FETCH_R3D_RESULTS',
    DECODE: 'FETCH_DECODE_RESULTS',
    TRC_ENG: 'FETCH_TRC_ENG_RESULTS',
    TRC_SPA: 'FETCH_TRC_SPA_RESULTS',
    OL_ENG: 'FETCH_OL_ENG_RESULTS',
    OL_SPA: 'FETCH_OL_SPA_RESULTS',
    VOCABO_SPA: 'FETCH_VOCABO_SPA_RESULTS',
    VOCABO_ENG: 'FETCH_VOCABO_ENG_RESULTS',
    SPELLING: 'FETCH_SPELLING_RESULTS',
};

export const FETCH_ITEM_LEVEL_DETAILS = {
    START: 'FETCH_ITEM_LEVEL_DETAILS_START',
    SUCCESS: 'FETCH_ITEM_LEVEL_DETAILS_SUCCESS',
    ERROR: 'FETCH_ITEM_LEVEL_DETAILS_ERROR',
};

export const FETCH_R3D_INTERPS = {
    START: 'FETCH_R3D_INTERPS_START',
    SUCCESS: 'FETCH_R3D_INTERPS',
    ERROR: 'FETCH_R3D_INTERPS_ERROR',
};

export const FETCH_ALL_INTERPS = {
    START: 'FETCH_INTERPS_START',
    SUCCESS: 'ALL_INTERPS_FETCHED',
    ERROR: 'FETCH_INTERPS_ERROR',
};

export const FETCH_SHARED_INTERPS = {
    R3D: 'R3D_INTERPS_FETCHED',
    VOCABO: 'FETCH_VOCABO_INTERPS',
    OL: 'FETCH_OL_INTERPS',
    SPELLING: 'FETCH_SPELLING_INTERPS',
};

export const FETCH_INTERCOM_INFO = {
    START: 'FETCH_INTERCOM_INFO_START',
    SUCCESS: 'FETCH_INTERCOM_INFO_SUCCESS',
    ERROR: 'FETCH_INTERCOM_INFO_ERROR',
};

export const PERCENTILE_TOGGLE_STATE = {
    SET: 'SET_PERCENTILE_TOGGLE_STATE',
    CLEAR: 'CLEAR_PERCENTILE_TOGGLE_STATE',
};

export const SWITCH_PERIOD = 'SWITCH_PERIOD';
export const SWITCH_PM_PERIOD = 'SWITCH_PM_PERIOD';

export const CLEAR_R3D_INTERPS = 'CLEAR_R3D_INTERPS';
export const CLEAR_RESULTS = 'CLEAR_RESULTS';
export const CLEAR_ADDITIONAL_ENROLLMENT_INFO = 'CLEAR_ADDITIONAL_ENROLLMENT_INFO';
export const SWITCH_DUAL_LANGUAGE_GRADE = 'SWITCH_DUAL_LANGUAGE_GRADE';

export const SAVE_BASIC_COMPREHENSION_RESULT = {
    START: 'SAVE_BASIC_COMPREHENSION_RESULT_START',
    SUCCESS: 'SAVE_BASIC_COMPREHENSION_RESULT_SUCCESS',
    ERROR: 'SAVE_BASIC_COMPREHENSION_RESULT_ERROR',
};

export const INVALIDATE_BASIC_COMPREHENSION_RESULT = {
    START: 'INVALIDATE_BASIC_COMPREHENSION_RESULT_START',
    SUCCESS: 'INVALIDATE_BASIC_COMPREHENSION_RESULT_SUCCESS',
    ERROR: 'INVALIDATE_BASIC_COMPREHENSION_RESULT_ERROR',
};

export const FETCH_FORM_IDS_FOR_MULTIPLE_GRADES = {
    START: 'FETCH_FORM_IDS_FOR_MULTIPLE_GRADES_START',
    SUCCESS: 'FETCH_FORM_IDS_FOR_MULTIPLE_GRADES_SUCCESS',
    ERROR: 'FETCH_FORM_IDS_FOR_MULTIPLE_GRADES_ERROR',
};

export const SWITCH_INSTRUCTION_DATE = 'SWITCH_INSTRUCTION_DATE';
export const SWITCH_INSTRUCTION_GRADE = 'SWITCH_INSTRUCTION_GRADE';
export const VIEW_LATEST_UPDATE_RECOMMENDATION = 'VIEW_LATEST_UPDATE_RECOMMENDATION';

export const FETCH_CHECKPOINTS = {
    START: 'FETCH_CHECKPOINTS_START',
    SUCCESS: 'FETCH_CHECKPOINTS_SUCCESS',
    ERROR: 'FETCH_CHECKPOINTS_ERROR',
};

export const FETCH_FAKE_CHECKPOINTS = {
    START: 'FETCH_FAKE_CHECKPOINTS_START',
    SUCCESS: 'FETCH_FAKE_CHECKPOINTS_SUCCESS',
    ERROR: 'FETCH_FAKE_CHECKPOINTS_ERROR',
};

export const SAVE_CHECKPOINT = {
    START: 'SAVE_CHECKPOINT_START',
    SUCCESS: 'SAVE_CHECKPOINT_SUCCESS',
    ERROR: 'SAVE_CHECKPOINT_ERROR',
};

export const CLEAR_CHECKPOINTS = 'CLEAR_CHECKPOINTS';

export const CLEAR_BASIC_COMPREHENSION_WEB_ENTRY_DATA = 'CLEAR_BASIC_COMPREHENSION_WEB_ENTRY_DATA';
export const UPDATE_ROW_STATUS_OBJECT = 'UPDATE_ROW_STATUS_OBJECT';

export const GENERATE_PDF = 'GENERATE_PDF';

export const DOWNLOAD_PDF = {
    START: 'DOWNLOAD_PDF_START',
    SUCCESS: 'DOWNLOAD_PDF_SUCCESS',
    ERROR: 'DOWNLOAD_PDF_ERROR',
};

export const CLOSE_SNACK_BAR = 'CLOSE_SNACK_BAR';

export const SELECT_STUDENT = 'SELECT_STUDENT';

export const FETCH_STUDENT_ENROLLMENT_INFO = {
    START: 'FETCH_STUDENT_ENROLLMENT_INFO_START',
    SUCCESS: 'FETCH_STUDENT_ENROLLMENT_INFO_SUCCESS',
    ERROR: 'FETCH_STUDENT_ENROLLMENT_INFO_ERROR',
};

export const FETCH_ALL_STUDENTS_ENROLLMENT_INFO = {
    START: 'FETCH_ALL_STUDENTS_ENROLLMENT_INFO_START',
    SUCCESS: 'FETCH_ALL_STUDENTS_ENROLLMENT_INFO_SUCCESS',
    ERROR: 'FETCH_ALL_STUDENTS_ENROLLMENT_INFO_ERROR',
};

export const CLEAR_ENROLLMENT_INFO = 'CLEAR_ENROLLMENT_INFO';

export const CLEAR_STUDENT_SUMMARY_DATA = 'CLEAR_STUDENT_SUMMARY_DATA';
export const SELECT_GRADE_YEAR = 'SELECT_GRADE_YEAR';

export const SWITCH_GRADE = 'SWITCH_GRADE';

export const FETCH_ALL_OBSERVATIONS = {
    START: 'FETCH_ALL_OBSERVATIONS_START',
    SUCCESS: 'FETCH_ALL_OBSERVATIONS_SUCCESS',
    ERROR: 'FETCH_ALL_OBSERVATIONS_ERROR',
};

export const FETCH_PDF_AVAILABILITY = {
    START: 'FETCH_PDF_AVAILABILITY_START',
    SUCCESS: 'FETCH_PDF_AVAILABILITY_SUCCESS',
    ERROR: 'FETCH_PDF_AVAILABILITY_ERROR',
};

export const UPLOAD_PDF_AVAILABILITY = {
    START: 'UPLOAD_PDF_AVAILABILITY_START',
    SUCCESS: 'UPLOAD_PDF_AVAILABILITY_SUCCESS',
    ERROR: 'UPLOAD_PDF_AVAILABILITY_ERROR',
};

export const SWITCH_GROWTH_ANALYSIS_PERIOD = 'SWITCH_GROWTH_ANALYSIS_PERIOD';

export const FETCH_STUDENT_GOALS = {
    START: 'FETCH_STUDENT_GOALS',
    SUCCESS: 'FETCH_STUDENT_GOALS_SUCCESS',
    ERROR: 'FETCH_STUDENT_GOALS_ERROR',
};

export const SAVE_STUDENT_GOAL = {
    START: 'SAVE_STUDENT_GOAL_START',
    SUCCESS: 'SAVE_STUDENT_GOAL_SUCCESS',
    ERROR: 'SAVE_STUDENT_GOAL_ERROR',
};
